"use strict";

exports.resolve = (val, ...args) => {
  if (typeof val === 'function') {
    return val(...args);
  }

  return val;
};

exports.resolveWith = (applyTo, val, ...args) => {
  if (typeof val === 'function') {
    return val.apply(applyTo, args);
  }

  return val;
};

exports.resolveProp = (obj, key, ...args) => {
  const val = obj && obj[key];

  if (typeof val === 'function') {
    return obj[key](...args);
  }

  return val;
};

exports.resolveAsync = async (...args) => {
  return exports.resolve(...args);
};

exports.resolveWithAsync = async (...args) => {
  return exports.resolveWith(...args);
};

exports.resolvePropAsync = async (...args) => {
  return exports.resolveProp(...args);
};

exports.R = exports.resolve;
exports.RW = exports.resolveWith;
exports.RP = exports.resolveProp;
exports.RA = exports.resolveAsync;
exports.RWA = exports.resolveWithAsync;
exports.RPA = exports.resolvePropAsync;